type Callback = (x: any) => any

// root container for the callbacks
export const callbacks: { [key: string]: Callback[] } = {}

export const isCallbacksEmpty = (baseKey: string, key: string): boolean => {
    return callbacks[baseKey + key]?.length < 1
}

const pubSub = {
    on: (key: string, callback: Callback) => {
        if (!callbacks[key]) {
            callbacks[key] = []
        }
        callbacks[key].push(callback)
        return () => pubSub.destroy(key, callback)
    },
    destroy: (key: string, callback: Callback) => {
        if (!callbacks[key]) {
            return
        }

        callbacks[key] = callbacks[key].filter(
            (existing: Callback) => existing !== callback,
        )
        if (callbacks[key].length < 1) {
            delete callbacks[key]
        }
    },
    emit: (key: string, data: any, immediate = false) => {
        if (!callbacks[key]) {
            return
        }
        if (immediate) {
            // allow for forcing an immediate flush, making it easier to
            // ensure data is where it needs to be in certain situations
            callbacks[key].forEach((callback: Callback) => callback(data))
        } else {
            callbacks[key].forEach((callback: Callback) =>
                setTimeout(() => callback(data), 0),
            )
        }
    },
}

type Interceptors = {
    on?(key: string, data: any): any
    off?(key: string, data: any): any
}

export const createPubSub = (prefix: string, interceptors?: Interceptors) => ({
    on: (key: string, callback: Callback, data?: any) => {
        interceptors?.on?.(key, data)
        pubSub.on(prefix + key, callback)

        return () => {
            interceptors?.off?.(key, data)
            pubSub.destroy(prefix + key, callback)
        }
    },
    destroy: (key: string, callback: Callback, data?: any) => {
        interceptors?.off?.(key, data)
        pubSub.destroy(prefix + key, callback)
    },
    emit: (key: string, data?: any, immediate = false) =>
        pubSub.emit(prefix + key, data, immediate),
})
